import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Container, Tab, Nav, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import Search from "./Search";
import Display from "./Display";
import Social from "./Social";
import Video from "./Video";
import BackButton from "../BackButton";
import NextButton from "../NextButton";
import SkipButton from "../SkipButton";
import getNextPage from "../getNextPage";
import { RouterContext } from "../Onboarding";
import jsDig from "utils/jsDig";

export default function Inflation(props) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);

  props.pageLocator();
  const [tabLocation, setTabLocation] = useState("");
  useEffect(() => {
    let searchParams = new URL(location.href).searchParams;
    let page = searchParams.get("page");
    if (!page || page == "") {
      page = "search";
    }
    setTabLocation(page);
  }, []);

  const selectTab = (key) => {
    setTabLocation(key);
  };
  let validatedInit = true;

  // No inflation for social
  const enabledServices = [];
  if (props.search_section.enabled) enabledServices.push("search");
  if (props.display_section.enabled) enabledServices.push("display");
  if (props.video_section.enabled) enabledServices.push("video");

  for (const service in props.inflation) {
    if (enabledServices.includes(service)) {
      for (const platform in props.inflation[service]) {
        for (const metric in props.inflation[service][platform]) {
          if (jsDig([service, platform, metric], props.inflation)) {
            const array = Object.values(props.inflation[service][platform][metric]);
            if (
              Object.values(props.inflation[service][platform][metric])
                .slice(0, array.length - 1)
                .includes("")
            )
              validatedInit = false;
          }
        }
      }
    }
  }
  const [validated, setValidatation] = useState(validatedInit);
  useEffect(() => {
    let validation = true;
    for (const service in props.inflation) {
      if (enabledServices.includes(service)) {
        for (const platform in props.inflation[service]) {
          for (const metric in props.inflation[service][platform]) {
            if (jsDig([service, platform, metric], props.inflation)) {
              const array = Object.values(props.inflation[service][platform][metric]);

              if (
                Object.values(props.inflation[service][platform][metric])
                  .slice(0, array.length - 1)
                  .includes("")
              )
                validation = false;
            }
          }
        }
      }
    }
    setValidatation(validation);
  });
  return (
    <Container fluid className="px-5 collapse-padding-mobile">
      <Row className="px-4 mb-3 pb-3 justify-content-center collapse-padding-mobile">
        <Col md={7}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Inflation</p>
          </div>
          <div>
            <p className=" f14 nunito-regular primary ">
              Here you can set values for inflation. You can do so manually, import values from a CSV, or import directly from the accounts that you linked on
              the previous pages in this access section. You can also copy and paste from Google.
            </p>
          </div>
        </Col>
      </Row>
      <Row className="pb-2">
        <Col className="text-right">
          <div className="mx-5 collapse-margin-mobile">
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
      <div className="mx-5 tab-shadow collapse-margin-mobile">
        <Tab.Container id="account-config-tabs" defaultActiveKey="search" activeKey={tabLocation} onSelect={(k) => selectTab(k)}>
          <Nav variant="pills" className="pt-0  pb-0 nav-fill tabs-navigation-2 row no-gutters row-cols-sm-1 row-cols-md-2 row-cols-lg-4 trim-padding">
            <Nav.Item className="col">
              <Nav.Link eventKey="search" className="tab-titles">
                Search
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="col">
              <Nav.Link eventKey="social">Social</Nav.Link>
            </Nav.Item>
            <Nav.Item className="col">
              <Nav.Link eventKey="display" className="tab-titles">
                Display
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="col">
              <Nav.Link eventKey="video" className="tab-titles">
                Video
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="search">
              {props.search_section.enabled ? (
                <Search inflation={props.inflation} setInflation={props.setInflation} />
              ) : (
                <div style={{ backgroundColor: "#F5F5F5" }}>
                  <Row className="p-4">
                    <Col>
                      <div className="py-4">
                        <p>Search is not currently enabled</p>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="social">
              <Social {...props} />
            </Tab.Pane>
            <Tab.Pane eventKey="display">
              {props.display_section.enabled ? (
                <Display inflation={props.inflation} setInflation={props.setInflation} />
              ) : (
                <div style={{ backgroundColor: "#F5F5F5" }}>
                  <Row className="p-4">
                    <Col>
                      <div className="py-4">
                        <p>Display is not currently enabled</p>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </Tab.Pane>
            <Tab.Pane eventKey="video">
              {props.video_section.enabled ? (
                <Video inflation={props.inflation} setInflation={props.setInflation} />
              ) : (
                <div style={{ backgroundColor: "#F5F5F5" }}>
                  <Row className="p-4">
                    <Col>
                      <div className="py-4">
                        <p>Video is not currently enabled</p>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
      <Row className="mt-5 ">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
